import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/client/lib/api-client'

export interface MetaSuggestionItem {
  text: string
  charCount: number
  reasoning: string
}

export interface MetaSuggestionsResponse {
  available: boolean
  titles?: MetaSuggestionItem[]
  descriptions?: MetaSuggestionItem[]
}

export function useMetaSuggestions(crawlId: string, pageId: number) {
  return useQuery({
    queryKey: ['crawls', crawlId, 'pages', pageId, 'suggestions'],
    queryFn: () => apiClient.get<MetaSuggestionsResponse>(`/api/crawls/${crawlId}/pages/${pageId}/suggestions`),
    enabled: false, // Manual trigger via refetch()
    staleTime: 24 * 60 * 60 * 1000, // 24hr
  })
}
